import { useNavigate, useParams } from 'react-router-dom';
import { useAuthStore } from '@/state/store/auth';
import { useActiveOrganization } from '@/graphql/queries/organizations';
import { IntegrationsSettings } from '../components/integrations-settings';
import { useTranslation } from 'react-i18next';

export default function SettingsIntegrationsPage() {
  const navigate = useNavigate();
  const { orgId: slug } = useParams<{ orgId: string }>();
  const { userId, activeOrgRole } = useAuthStore();
  const { data: organization, isLoading } = useActiveOrganization();
  const { t } = useTranslation();

  if (!userId) {
    navigate('/login');
    return null;
  }

  if (activeOrgRole !== 'org_admin') {
    navigate(`/org/${slug}`);
    return null;
  }

  if (isLoading || !organization) {
    return null;
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-[hsl(var(--fg))] font-heading">
          {t('ORGSETTINGS_INTEGRATIONS_LABEL')}
        </h2>
        <p className="text-sm text-globe-grey mt-1">{t('ORGSETTINGS_INTEGRATIONS_DESCRIPTION')}</p>
      </div>

      <IntegrationsSettings org={organization} />
    </div>
  );
}
